import React, { useState, useContext } from "react";
import UserContext from "contexts/UserContext";
import ReportAccessModal from "components/ReportAccessModal";
import { useHistory } from "react-router-dom";

const AccessModalWrapper = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const user = useContext(UserContext);
  const [accessReason, setAccessReason] = useState(undefined);
  const [isGranted, setIsGranted] = useState(user.isParent | user.isTeacher);
  return isGranted ? (
    <Component accessReason={accessReason} {...rest} />
  ) : (
    <ReportAccessModal
      open={!isGranted}
      onSubmit={(reason) => {
        setAccessReason(reason);
        setIsGranted(reason);
      }}
      onClose={() => {
        history.goBack();
      }}
    />
  );
};

export default AccessModalWrapper;
